import * as XLSX from 'xlsx';

import { CommonModule } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { Store } from '@ngrx/store';

import { MatTooltipModule } from '@angular/material/tooltip';
import { ExcelPreviewDialogComponent } from '@components';
import { DateRange } from '@enums';
import { UtilService } from '@services';
import {
    fetchPayRollBatches,
    selectPayRollBatches,
    selectPayRollsFetchedAt,
} from '@state';
import * as PayRollActions from '@state/pay-roll/pay-roll.actions';

@Component({
  selector: 'app-pay-roll-batch-upload',
  standalone: true,
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatFormFieldModule,
    MatSelectModule,
    MatTableModule,
    MatButtonModule,
    MatTooltipModule,
  ],
  templateUrl: './pay-roll-batch-upload.component.html',
  styleUrl: './pay-roll-batch-upload.component.scss',
})
export class PayRollBatchUploadComponent {
  $payRollBatches = this.store.select(selectPayRollBatches);
  $payRollBatchesFetchedAt = this.store.select(selectPayRollsFetchedAt);

  public selectedDateRange: DateRange = DateRange.LAST_7_DAYS;

  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  public dateRanges: string[] = Object.values(DateRange);
  public columns: string[] = [
    'fileName',
    'totalRecords',
    'processedCount',
    'failedCount',
    'status',
    'actions',
  ];

  constructor(
    private store: Store,
    private dialog: MatDialog,
    public utils: UtilService
  ) {}

  public ngOnInit(): void {
    this.store.dispatch(fetchPayRollBatches());
  }

  public onPayRollBatchUploadClicked(): void {
    this.fileInput.nativeElement.click();
  }

  public onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.previewFile(file, false);
    }
  }

  public previewFile(file: File, viewOnly: boolean): void {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      const dialogRef = this.dialog.open(ExcelPreviewDialogComponent, {
        width: '90%',
        maxWidth: '95vw',
        data: { fileName: file.name, previewData: jsonData, viewOnly },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result === 'upload') {
          this.store.dispatch(PayRollActions.uploadPayRollBatch({ file }));
        }
        this.fileInput.nativeElement.value = '';
      });
    };
    reader.readAsArrayBuffer(file);
  }

  public downloadFile(url: string): void {
    window.open(url);
  }

  public processBatchUpload(payRollBatchId: string): void {
    this.store.dispatch(PayRollActions.processPayRollBatch({ payRollBatchId }));
  }
}
